




































































import {Component} from 'vue-property-decorator'
import Portfolio from "@/lib/models/Portfolio";
import PortfolioItem from "../../components/portfolio/item.vue";
import UserMixin from "@/lib/mixins/UserMixin";
import EditModal from "../../components/portfolio/editModal.vue";
import EditMovementModal from "../../components/portfolio/editMovementModal.vue";
import EditPriceUpdateModal from "../../components/portfolio/editPriceUpdateModal.vue";
import MonthStats from "../../components/portfolio/monthStats.vue";
import {mixins} from "vue-class-component";
import PortfolioMove from "@/lib/models/PortfolioMove";
import BankAccount from "@/lib/models/BankAccount";
import PriceUpdate from "@/lib/models/PriceUpdate";
import CurrencyApi from "@/lib/CurrencyApi";

@Component({
    components: {
        PortfolioItem,
        EditModal,
        EditMovementModal,
        EditPriceUpdateModal,
        MonthStats
    },
  filters: {
      skCurrencyFormat: function(value: number){
        return new Intl.NumberFormat('sk-SK', { maximumSignificantDigits: 3, style: 'currency', currency: 'EUR' }).format(value);
      }
  }
})
export default class PortfolioView extends mixins(UserMixin) {
    private $firebase: any;
    private loaded: boolean = false;
    private portfolios: Portfolio[] = [];
    private expandedPortfolios: Portfolio[] = [];
    private accounts: BankAccount[] = [];
    private portfolioToEdit: Portfolio | null = null;
    private priceUpdateToEdit: PriceUpdate | null = null;
    private portfolioMovementToEdit: PortfolioMove | null = null;
    private collection: firebase.database.Reference | null = null;

    totalInvested: number = 0;
    totalValue: number = 0;

    //

    created() {
        this.collection = this.$firebase.database().ref('portfolio/' + this.loggedUser.uid);
        if (this.collection) {
            this.collection.on('value', (snapshot: any) => {
                if (!this.loaded) this.loaded = true;
                if (snapshot.val() !== null) {

                    const newPortfolios = Object.keys(snapshot.val()).map((key: string) => {
                        return (new Portfolio()).fromObject(snapshot.val()[key], {}, key) as Portfolio;
                    });

                    if (JSON.stringify(newPortfolios) !== JSON.stringify(this.portfolios)) {
                        this.portfolios = newPortfolios.slice();
                        this.reloadPortfolioData();
                    }
                }
            });
        }
        this.$firebase.database().ref('account/' + this.loggedUser.uid).on('value', (snapshot: any) => {
            if (!this.loaded) this.loaded = true;
            if (snapshot.val() !== null) {
                this.accounts = Object.keys(snapshot.val()).map((key: string) => {
                    return (new BankAccount()).fromObject(snapshot.val()[key], {}, key) as BankAccount;
                });
            }
        });
    }

    reloadPortfolioData() {
        if (this.portfolios) {
            (new CurrencyApi()).getCurrencyList('EUR', ['USD']).then((list) => {

              console.log(list);
              if(list !== undefined) {
                this.totalValue = Number(this.portfolios.reduce((p, c) => {

                  let inv = Number(c.latestUpdateValue());
                  if (c.currency !== null && list[c.currency.code as number]) {
                    inv = inv / (list[c.currency.code as number] as unknown as number)
                  }
                  return p + inv

                }, 0));
                this.totalInvested = Number(this.portfolios.reduce((p, c) => {
                  let inv = Number(c.totalInvested());
                  if (c.currency !== null && list[c.currency.code as number]) {
                    inv = inv / (list[c.currency.code as number] as unknown as number)
                  }
                  return p + inv
                }, 0).toFixed(2));
              }
            }).catch(e => {
              console.log(e);
            })
        }
    }

    createPortfolio() {
        if (this.collection !== null) {
            const newPortfolio = (new Portfolio()).fromObject({
                name: "New portfolio"
            });
            this.collection.push().set(newPortfolio)
        }
    }

    private isExpanded(portfolio: Portfolio) {
        return this.expandedPortfolios.some(p => p.id === portfolio.id);
    }


    public toggleEditModal(portfolio: Portfolio | undefined) {
        this.portfolioToEdit = portfolio ? portfolio : null;
        (this.$refs.editModalRef as EditModal).toggle();
    }


    public expandPortfolio(portfolio: Portfolio) {
        if (this.expandedPortfolios.some(p => p.id === portfolio.id)) {
            this.expandedPortfolios = this.expandedPortfolios.filter(p => p.id !== portfolio.id);
        } else {
            this.expandedPortfolios.push(portfolio);
        }
    }

    public toggleEditMovement(portfolio: Portfolio | undefined, portfolioMovement: PortfolioMove | null) {
        this.portfolioToEdit = portfolio ? portfolio : null;
        this.portfolioMovementToEdit = portfolioMovement ? portfolioMovement : (new PortfolioMove());
        (this.$refs.editMovementModalRef as EditMovementModal).toggle();
    }

    public toggleEditPriceUpdate(portfolio: Portfolio | undefined, priceUpdate: PriceUpdate | null) {
        this.portfolioToEdit = portfolio ? portfolio : null;
        this.priceUpdateToEdit = priceUpdate ? priceUpdate : (new PriceUpdate());
        (this.$refs.editPriceMoveRef as EditPriceUpdateModal).toggle();
    }
}
